import { useEffect } from 'react';

import { FullScreenLoadingBox } from 'components';

import { OidcContext } from '@britishcouncil/react-oidc-auth';

//[GP] - this component is required for emails links that should redirect directly to login page
export const LoginInit = () => {
  const userManager = OidcContext.useAuth();

  useEffect(() => {
    userManager.signinRedirect();
  }, [userManager]);

  return <FullScreenLoadingBox />;
};
